module.exports = __webpack_public_path__ + "img/require.fa8cc365.jpg";